import * as x from '../helpers/xmlHelpers';

export class PropertyDetail {
    constructor(doc)
    {
		this.label = null
		this.accessoryDwellingUnitTotalCount = null
		this.attachmentType = null
		this.communityLandTrustIndicator = null
		this.constructionStatusType = null
		this.cooperativeProprietaryLeaseExpirationDate = null
		this.dwellingCount = null
		this.functionalIssueDescription = null
		this.homeownerResponsibleForExteriorMaintenanceIndicator = null
		this.livingUnitExcludingADUCount = null
		this.mineralRightsLeasedIndicator = null
		this.nativeAmericanLandsIndicator = null
		this.nativeAmericanLandsType = null
		this.nativeAmericanLandsTypeOtherDescription = null
		this.newConstructionIndicator = null
		this.overallConditionRatingCode = null
		this.overallQualityRatingCode = null
		this.priorSalesOrTransfersIndicator = null
		this.priorSalesOrTransfersLabel = null;
		this.propertyAmenityExistsIndicator = null
		this.propertyCooperativeSharesCount = null
		this.propertyEstateType = null
		this.propertyEstateTypeOtherDescription = null
		this.propertyInProjectIndicator = null
		this.proRataSharePercent = null
		this.PUDIndicator = null
		this.subjectPropertyAmenitiesDefectsExistIndicator = null
		this.totalFinishedAreaOfAllLivingUnitsIncludingADUAreaMeasure = null
		this.totalOfAllDwellingsVolumeMeasure = null
		this.totalWindowSurfaceAreaOfAllDwellingsAreaMeasure = null
		this.vehicleStorageDefectsExistIndicator = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.accessoryDwellingUnitTotalCount = x.getIntegerElement(doc, "./ns:AccessoryDwellingUnitTotalCount");
		this.attachmentType = x.getStringElement(doc, "./ns:AttachmentType");
		this.communityLandTrustIndicator = x.getBooleanElement(doc, "./ns:CommunityLandTrustIndicator");
		this.constructionStatusType = x.getStringElement(doc, "./ns:ConstructionStatusType");
		this.cooperativeProprietaryLeaseExpirationDate = x.getMISMODateElement(doc, "./ns:CooperativeProprietaryLeaseExpirationDate");
		this.dwellingCount = x.getIntegerElement(doc, "./ns:DwellingCount");
		this.functionalIssueDescription = x.getStringElement(doc, "./ns:FunctionalIssueDescription");
		this.homeownerResponsibleForExteriorMaintenanceIndicator = x.getBooleanElement(doc, "./ns:HomeownerResponsibleForExteriorMaintenanceIndicator");
		this.livingUnitExcludingADUCount = x.getIntegerElement(doc, "./ns:LivingUnitExcludingADUCount");
		this.mineralRightsLeasedIndicator = x.getBooleanElement(doc, "./ns:MineralRightsLeasedIndicator");
		this.nativeAmericanLandsIndicator = x.getBooleanElement(doc, "./ns:NativeAmericanLandsIndicator");
		this.nativeAmericanLandsType = x.getStringElement(doc, "./ns:NativeAmericanLandsType");
		this.nativeAmericanLandsTypeOtherDescription = x.getStringElement(doc, "./ns:NativeAmericanLandsTypeOtherDescription");
		this.newConstructionIndicator = x.getBooleanElement(doc, "./ns:NewConstructionIndicator");
		this.overallConditionRatingCode = x.getStringElement(doc, "./ns:OverallConditionRatingCode");
		this.overallQualityRatingCode = x.getStringElement(doc, "./ns:OverallQualityRatingCode");
		this.priorSalesOrTransfersIndicator = x.getBooleanElement(doc, "./ns:PriorSalesOrTransfersIndicator");
		this.propertyAmenityExistsIndicator = x.getBooleanElement(doc, "./ns:PropertyAmenityExistsIndicator");
		this.propertyCooperativeSharesCount = x.getIntegerElement(doc, "./ns:PropertyCooperativeSharesCount");
		this.propertyEstateType = x.getStringElement(doc, "./ns:PropertyEstateType");
		this.propertyEstateTypeOtherDescription = x.getStringElement(doc, "./ns:PropertyEstateTypeOtherDescription");
		this.propertyInProjectIndicator = x.getBooleanElement(doc, "./ns:PropertyInProjectIndicator");
		this.proRataSharePercent = x.getStringElement(doc, "./ns:ProRataSharePercent");
		this.PUDIndicator = x.getBooleanElement(doc, "./ns:PUDIndicator");
		this.subjectPropertyAmenitiesDefectsExistIndicator = x.getBooleanElement(doc, "./ns:SubjectPropertyAmenitiesDefectsExistIndicator");
		this.totalFinishedAreaOfAllLivingUnitsIncludingADUAreaMeasure = x.getMISMOMeasureElement(doc, "./ns:TotalFinishedAreaOfAllLivingUnitsIncludingADUAreaMeasure");
		this.totalOfAllDwellingsVolumeMeasure = x.getMISMOMeasureElement(doc, "./ns:TotalOfAllDwellingsVolumeMeasure");
		this.totalWindowSurfaceAreaOfAllDwellingsAreaMeasure = x.getMISMOMeasureElement(doc, "./ns:TotalWindowSurfaceAreaOfAllDwellingsAreaMeasure");
		this.vehicleStorageDefectsExistIndicator = x.getBooleanElement(doc, "./ns:VehicleStorageDefectsExistIndicator");

		var node = x.selectSingleNode(doc, "./ns:PriorSalesOrTransfersIndicator");
		if (node !== null)
			this.priorSalesOrTransfersLabel = x.getStringAttribute(node, "xlink:label");

   }
}

